module.exports = __webpack_public_path__ + "static/media/IndegeneLogo.db535e59.svg";